import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./Button.scss";
import "../../styles/colors.scss";

export default function Button({
  className,
  children,
  color,
  disabled,
  form,
  name,
  onClick,
  size,
  tabIndex,
  type,
  value,
  ...otherProps
}) {
  const classnames = cx(
    "Button",
    {
      [`Button--${color}`]: color,
      "Button--disabled": disabled,
      [`Button--${size}`]: size
    },
    className
  );

  return (
    <button
      className={classnames}
      disabled={disabled}
      form={form}
      name={name}
      onClick={onClick}
      tabIndex={tabIndex}
      type={type}
      value={value}
      {...otherProps}
    >
      {children}
    </button>
  );
}

// Values marked with ** should be translated strings
Button.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]),
  children: PropTypes.oneOfType([ //**
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ]),
  color: PropTypes.oneOf(["white", "transparent"]),
  disabled: PropTypes.bool,
  form: PropTypes.string,
  name: PropTypes.string, //**
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["big", "small"]),
  tabIndex: PropTypes.number,
  type: PropTypes.oneOf([
    "button",
    "reset",
    "submit"
  ]),
  value: PropTypes.string //**
};

Button.defaultProps = {
  size: "big",
  type: "button",
  tabIndex: 0
};
